var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("img", {
        staticClass:
          "account-verification__step__icon verification-method-selection__icon",
        attrs: { src: _vm.icons.accountVerification },
      }),
      _vm._v(" "),
      _c("h1", { staticClass: "account-verification__step__title" }, [
        _vm._v("\n    Select a verification method.\n  "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "account-verification__step__description" }, [
        _vm._v("\n    How would they like to verify their account?\n  "),
      ]),
      _vm._v(" "),
      _c("verification-method-select", {
        on: {
          methodSelected: _vm.setVerificationMethod,
          verificationChannelsUpdated:
            _vm.propagateAvailableVerificationChannels,
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "verification-method-selection__step__right-aligned-button-container",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "account-verification__step__button",
              attrs: {
                disabled: _vm.verificationMethod === null,
                type: "primary",
              },
              on: { click: _vm.notifyContinue },
            },
            [_vm._v("\n      Continue\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }